'use client';

import { useTranslation } from 'react-i18next';

import { LinkStyle } from '@sola/ark-core/atoms/link-style/link-style.js';
import { ActionCardFooter } from '@sola/ark-core/molecules/action-card/action-card.js';
import {
  Dialog,
  DialogActions,
  DialogClose,
  DialogContent,
  DialogTrigger,
} from '@sola/ark-core/molecules/dialog/dialog.js';
import {
  GraphQLCommitment,
  GraphQLSupporterPaymentMethod,
} from '@sola/schema/dotcom/supporters/schema.generated.js';

export const DialogRemovePaymentMethod: React.FC<{
  handleRemove: () => void;
}> = ({ handleRemove }) => {
  const { t } = useTranslation('my');

  return (
    <Dialog>
      <DialogTrigger>
        <LinkStyle noUnderline noPadding size="lg" purpose="negative">
          <button
            type="button"
            // className="label-md label-potent lg:label-lg"
          >
            {t('payments.removeMethod')}
          </button>
        </LinkStyle>
      </DialogTrigger>
      <DialogContent
        size="sm"
        footer={
          <DialogActions
            primaryBtn={{
              children: (
                <button onClick={handleRemove} type="button">
                  {t('payments.removeMethodDialog.remove')}
                </button>
              ),
              purpose: 'negative',
            }}
            secondaryBtn={{
              children: (
                <DialogClose>
                  <button type="button">
                    {t('payments.removeMethodDialog.cancel')}
                  </button>
                </DialogClose>
              ),
            }}
          />
        }
        icon="info-circle"
        title={t('payments.removeMethodDialog.title')}
        supportingText={t('payments.removeMethodDialog.supportingText')}
        purpose="negative"
      />
    </Dialog>
  );
};

export type PaymentMethodCardFooterProps = {
  paymentMethod: GraphQLSupporterPaymentMethod;
  recurringCommitments?: GraphQLCommitment[];
  onRemoveSuccess?: () => void;
  onRemoveError?: () => void;
};

export const PaymentMethodCardFooter: React.FC<
  PaymentMethodCardFooterProps
> = ({ paymentMethod, recurringCommitments = [] }) => {
  // TODO in future stories.
  const handleEdit = () => null;
  const handleRemove = () => null;
  const handleSetPrimary = () => null;
  const isShowingRemoveBtn =
    !recurringCommitments?.length && !paymentMethod.isPrimary;
  const { t } = useTranslation('my');

  return (
    <ActionCardFooter>
      <div className="flex justify-between items-center">
        {!paymentMethod.isPrimary && (
          <LinkStyle noUnderline noPadding size="lg" purpose="neutral">
            <button onClick={handleSetPrimary} type="button">
              {t('payments.setPrimary')}
            </button>
          </LinkStyle>
        )}
        <div className="flex gap-comfy-md ml-auto">
          {isShowingRemoveBtn && (
            <DialogRemovePaymentMethod handleRemove={handleRemove} />
          )}
          <LinkStyle noUnderline noPadding size="lg">
            <button
              onClick={handleEdit}
              type="button"
              // className="label-md label-potent lg:label-lg"
            >
              {t('payments.editMethod')}
            </button>
          </LinkStyle>
        </div>
      </div>
    </ActionCardFooter>
  );
};
